import React from 'react';

import { Step } from '@vlabs/uikit';
import cn from 'classnames';

import st from './shared.module.sass';
import { FaceQualitySubForm } from '../../../forms';

function StepFaceQuality() {
  return (
    <Step
      className={cn(st.Step, st.NoTitle, st.FoldedStep)}
      withPadding={false}
    >
      <FaceQualitySubForm />
    </Step>
  );
}

StepFaceQuality.fieldNames = [
  'faceQuality',
];

export { StepFaceQuality };
